/**
 * Pick which token the `/sso` page persists as the app session.
 *
 * The partner deep-links a user in with a short-lived (120s) handoff token.
 * The `/sso` page exchanges it server-side for a normal full-length session
 * JWT (see `src/pages/Sso.tsx`). Prefer that exchanged token; fall back to the
 * raw handoff token when the exchange yielded nothing, so a frontend-before-
 * backend deploy degrades to the old 120s behaviour instead of breaking SSO.
 *
 * Admin accounts are never accepted. Partner SSO must not mint an Autoclipper
 * staff session from a deep-link, even when a valid handoff or exchanged JWT
 * is present.
 */
export function resolveSessionToken(
  { exchangedJwt, fallbackToken, isAdmin = false }: {
    exchangedJwt: string | null;
    fallbackToken: string | null;
    isAdmin?: boolean;
  },
): string | null {
  if (isAdmin) return null;
  return exchangedJwt || fallbackToken || null;
}
